import React from "react";
import { Code } from "rebass";
import styled from "styled-components";
import P from "./P";

const PBorder = styled.div`
    border-left: 8px solid #e13683;
    margin: 4px 0;
`;

const Command = ({ children }) => (
    <PBorder>
        <P>
            <Code>{children}</Code>
        </P>
    </PBorder>
);

export default Command;



// WEBPACK FOOTER //
// ./src/components/Command.js